import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@ui/dialog";
import TranslatedText from "@components/items/display/TranslatedText";
import { SVG } from "@components/items/common/SVG";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { getCustomerQuota, redeemCredit } from "@lib/stores";
import { ContentEntitiesActions } from "@lib/fetchers/allowedContentEntities";

const CoinReplacmentDialog = ({
  trigger,
  open,
  setOpen,
  setOpenSuccessDialog,
  id,
}: {
  trigger: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSuccessDialog: React.Dispatch<React.SetStateAction<boolean>>;
  id: string | undefined;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleRedeem = () => {
    redeemCredit({ contentEntityId: id }, async () => {
      setIsLoading(true);
      try {
        const result =
          await ContentEntitiesActions.getAllowedContentEntitiesAsync();
        if (result) {
          await getCustomerQuota();
          setOpen(false);
          setTimeout(() => setOpenSuccessDialog(true), 300);
        }
      } catch (error) {
        console.error("Failed to fetch allowed content entities", error);
      } finally {
        setIsLoading(false);
      }
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger}
      <DialogContent className="flex w-[500px] flex-col items-center justify-center gap-5 bg-white py-8 sm:rounded-[20px] dark:border-none dark:bg-[#010D19]">
        <DialogHeader className="flex flex-col items-center justify-center gap-2">
          <DialogTitle className="text-[24px] font-bold">
            <TranslatedText
              text={`full-books.confirm-coin-replacment`}
              className="dark:text-white"
            />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription></DialogDescription>
        <div className="flex w-full flex-col items-center justify-center gap-5">
          <SVG src="/assets/icons/success-replacement.svg" />
          <div className="flex items-center justify-center gap-2 text-[20px] text-[#606060] dark:text-[#91949C]">
            <TranslatedText text={`full-books.replacment-statment-1`} />
            <span className="flex items-center justify-center gap-1 text-[14px] font-medium text-black dark:text-white">
              <SVG src="/assets/icons/coin.svg" className="h-5 w-5" />1
            </span>
            <TranslatedText text={`full-books.replacment-statment-2`} />
          </div>
          <ShadcnButton
            className="mt-8 flex w-[80%] items-center justify-center gap-1 bg-primary px-6 py-7 text-[20px] font-medium text-white hover:bg-primary hover:opacity-85 dark:bg-[#64A6E1] dark:text-[#010D19] dark:hover:bg-[#64A6E1]"
            isLoading={isLoading}
            onClick={handleRedeem}
          >
            <TranslatedText text="full-books.replace" />
          </ShadcnButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CoinReplacmentDialog;
